import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es";

import { useFormik, Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  FormHelperText,
  Switch,
  FormControlLabel,
  Divider,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import MDInput from "components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
// Eliminado import { Autocomplete as FormikAutocomplete } from "formik-mui-lab";
import PropTypes from "prop-types";
import { Grid, Card, Box } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { ToastContainer, toast, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLanguages, fetchData, saveData, saveImgFolder, getTags } from "./Data";
import colors from "assets/theme/base/colors";
import { UploadImageBanner } from "components/shared/UploadImageBanner";
import { Cropper } from "components/Cropper/Cropper";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Close } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
// TinyMCE 6.x (MIT) — sustituye a react-quill 2.0.0 / quill 1.3.7, que NO
// soportaba tablas: al pegar un <table> descartaba el marcado y dejaba el texto
// de las celdas concatenado. TinyMCE trae `plugins/table` (tablas editables) y
// `plugins/code` (botón Source code) en la edición community, sin api-key ni
// plugins premium.
import { Editor } from "@tinymce/tinymce-react";
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";
// Plugins de la edición gratuita (todos presentes en el paquete MIT).
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code"; // botón Source code
import "tinymce/plugins/codesample";
import "tinymce/plugins/directionality";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/image";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/preview";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table"; // tablas editables
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/wordcount";
// Skin y contenido: se sirven desde el propio bundle (nada de CDN de TinyMCE
// Cloud, que es producto de pago).
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/content/default/content.min.css";
import "../../../assets/css/masterAdmin.css";

// // Import required plugins
// import customParseFormat from "dayjs/plugin/customParseFormat";
// import localizedFormat from "dayjs/plugin/localizedFormat";
// import weekOfYear from "dayjs/plugin/weekOfYear";
// import isBetween from "dayjs/plugin/isBetween";
// import advancedFormat from "dayjs/plugin/advancedFormat";

// Extend Day.js with required plugins
dayjs.extend(customParseFormat);
// dayjs.extend(localizedFormat);
// dayjs.extend(weekOfYear);
// dayjs.extend(isBetween);
// dayjs.extend(advancedFormat);

function Edit() {
  const [idiomas, setIdiomas] = useState([]);
  const [idiomaSeleccionado, setIdiomaSeleccionado] = useState(null);
  const [tags, setTags] = useState([]);
  const [tagSelected, setTagSelected] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({
    ID: 0,
    LANGUAGE_ID: 1,
    ACTIVO: true,
    FECHA_PUBLICACION: dayjs().format("DD/MM/YYYY"), // Formats today's date as 'YYYY-MM-DD'
    IMAGEN: "",
    TITULO: "",
    DESC_CORTA: "",
    DESC_LARGA: "",
    SEO_TITLE: "",
    SEO_METAKEYWORD: "",
    SEO_METADESCRIPTION: "",
    SEO_URL_FRIENDLY: "",
    TAGS: [],
  });

  // const [data, setData] = useState({
  //   ID: 0,
  //   ACTIVO: true,
  //   IMAGEN: "",
  //   FECHA_PUBLICACION: "",
  //   LANGUAGE_ID: 1,
  //   TITULO: "1",
  //   DESC_CORTA: "",
  //   DESC_LARGA: "2",
  //   SEO_TITLE: "3",
  //   SEO_METAKEYWORD: "4",
  //   SEO_METADESCRIPTION: "5",
  //   SEO_URL_FRIENDLY: "6",
  // });
  useEffect(() => {
    const loadLanguages = async () => {
      const langs = await getLanguages();
      setIdiomas(langs);
      const idiomaPorDefecto = langs.find((idioma) => idioma.ID == 1);
      // Evita establecer el idioma por defecto aquí si ya tienes uno seleccionado
      if (idiomaPorDefecto && !idiomaSeleccionado) {
        setIdiomaSeleccionado(idiomaPorDefecto);
      }
      const tags = await getTags();
      // Convertir cada ID de tag a número si actualmente es una cadena
      const normalizedTags = tags.map((tag) => ({
        ID: +tag.ID, // Usando el operador unario '+' para convertir a número
        NOMBRE: tag.NOMBRE,
      }));

      setTags(normalizedTags);
    };
    loadLanguages();
  }, []);

  // Clave `${id}:${idioma}` ya cargada, para no repetir la petición.
  const cargaRef = useRef(null);

  useEffect(() => {
    // Carga los datos iniciales.
    const loadData = async () => {
      if (!idiomaSeleccionado) return;
      // Guarda: no volver a pedir el mismo registro/idioma ya cargado. Evita
      // recargas espurias cuando un evento que no cambia nada (p. ej. el
      // clic-away de un modal cerrando el Autocomplete de idioma) vuelve a
      // disparar el efecto con el MISMO id e idioma: eso pisaba el formulario.
      const clave = `${id}:${idiomaSeleccionado.ID}`;
      if (cargaRef.current === clave) return;
      cargaRef.current = clave;
      const data = await fetchData(id, idiomaSeleccionado.ID);
      var item = data[0];
      item.TAGS = item.TAGS ? JSON.parse(item.TAGS) : [];
      setTagSelected(item.TAGS);
      setData(item);
    };
    if (id > 0) {
      loadData();
    }
  }, [id, idiomaSeleccionado]);

  const handleIdiomaChange = (event, newValue) => {
    // newValue es el objeto de la opción seleccionada
    setIdiomaSeleccionado(newValue); // Guarda el idioma seleccionado si necesitas usarlo en otro lugar
  };
  // Synchronise the DatePicker with the loaded record ONLY when a record is
  // loaded or the language changes. We read the value from the Formik field
  // (single source of truth), never from `data` on every keystroke.
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const lastValidDateRef = useRef(selectedDate); // Ref to keep track of the last valid date

  useEffect(() => {
    if (data.FECHA_PUBLICACION) {
      const parsed = dayjs(data.FECHA_PUBLICACION, "DD/MM/YYYY");
      if (parsed.isValid()) {
        setSelectedDate(parsed);
        lastValidDateRef.current = parsed;
      }
    }
    // Intentionally tied to id + language: those are the only events that reload
    // the record. Changing the publication date must NOT reload anything.
  }, [id, idiomaSeleccionado]);

  const handleDateChange = (newValue) => {
    // The publication date is an ordinary form field. Changing it must only
    // update that field: no `data` mutation (which, combined with Formik's
    // `enableReinitialize`, reinitialised every other field from the loaded
    // snapshot and wiped whatever the user had typed).
    if (newValue && newValue.isValid()) {
      const fecha = newValue.format("DD/MM/YYYY");
      setSelectedDate(newValue);
      lastValidDateRef.current = newValue; // Update ref to the new valid date
      formikSetFieldValueRef.current?.("FECHA_PUBLICACION", fecha);
    } else {
      setSelectedDate(lastValidDateRef.current); // Reset to the last valid date if new value is invalid
    }
  };

  const CustomToastContent = ({ title, subtitle }) => (
    <div>
      <strong style={{ fontSize: "16px" }}>{title}</strong>
      {subtitle && <p style={{ fontSize: "14px" }}>{subtitle}</p>}
    </div>
  );
  CustomToastContent.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
  };
  CustomToastContent.defaultProps = {
    title: "¡Guardado correctamente!",
    subtitle: "",
  };

  const msgOk = (title, subtitle) =>
    toast.success(<CustomToastContent title={title} subtitle={subtitle} />, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    });

  const msgError = (title, subtitle) =>
    toast.error(<CustomToastContent title={title} subtitle={subtitle} />, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    });
  // Configuración del editor. Portada del toolbar de Quill + `table` (tablas
  // editables) + `code` (Source code), que es lo que motivó la migración.
  //
  // RUTAS DE ASSETS: el core se carga desde /tinymce/tinymce.min.js, y TinyMCE
  // resuelve skin/theme/plugins RELATIVOS a ese script. Si no se le dice otra
  // cosa, los pide como `/tinymce/skins/...` (bien) pero la instancia que
  // arranca dentro del chunk los pedía como `/static/js/skins/...` y el
  // `web.config` los servía con MIME `text/plain` -> el navegador los rechaza
  // y el editor se queda SIN SKIN (no pinta). Se declaran explícitamente para
  // que TODO salga de /tinymce/ y no haya dos rutas compitiendo.
  const TINYMCE_BASE = "/tinymce";
  const tinyMceInit = {
    license_key: "gpl", // edición community (MIT); sin api-key de TinyMCE Cloud
    base_url: TINYMCE_BASE,
    suffix: ".min",
    skin_url: `${TINYMCE_BASE}/skins/ui/oxide`,
    content_css: `${TINYMCE_BASE}/skins/content/default/content.min.css`,
    menubar: false,
    branding: false,
    promotion: false,
    height: 500,
    plugins: [
      "advlist",
      "anchor",
      "autolink",
      "charmap",
      "code",
      "codesample",
      "directionality",
      "fullscreen",
      "image",
      "insertdatetime",
      "link",
      "lists",
      "media",
      "pagebreak",
      "preview",
      "searchreplace",
      "table",
      "visualblocks",
      "wordcount",
    ],
    toolbar:
      "undo redo | blocks fontfamily fontsize | " +
      "bold italic underline strikethrough | forecolor backcolor | " +
      "alignleft aligncenter alignright alignjustify | " +
      "bullist numlist outdent indent | " +
      "table | link image media | blockquote codesample | " +
      "removeformat | code fullscreen",
    // Permite pegar tablas completas (`<table>`) conservando el marcado.
    paste_data_images: true,
    valid_children: "+body[style]",
    table_toolbar:
      "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | " +
      "tableinsertcolbefore tableinsertcolafter tabledeletecol",
    content_style:
      "body { font-family: Helvetica, Arial, sans-serif; font-size: 14px; } " +
      "table { border-collapse: collapse; } " +
      "table th, table td { border: 1px solid #ccc; padding: 6px 8px; } " +
      "table th { background: #f2f2f2; font-weight: 600; }",
  };

  // ── Editor: referencia a la instancia real del editor (para los botones) ──
  const editorRef = useRef(null);
  const handleEditorRef = (evt, editor) => {
    if (editor) editorRef.current = editor;
  };
  // Formik `setFieldValue` vive dentro del render prop de <Formik>; lo
  // capturamos en un ref para poder llamarlo desde estos handlers (que están
  // declarados fuera de ese scope).
  const formikSetFieldValueRef = useRef(null);
  const [showHtmlModal, setShowHtmlModal] = useState(false);
  const [htmlDraft, setHtmlDraft] = useState("");
  // HTML a volcar al editor tras cerrar el modal (null = nada pendiente).
  const [htmlPendiente, setHtmlPendiente] = useState(null);

  // Botón "Código HTML": abre un textarea con el HTML FUENTE del cuerpo.
  const openHtmlModal = () => {
    const editor = editorRef.current;
    const actual = editor ? editor.getContent() : "";
    setHtmlDraft(actual === "<p><br></p>" ? "" : actual);
    setShowHtmlModal(true);
  };
  // Al aceptar: cierra el modal y aplica el HTML en el efecto de abajo. No se
  // toca el editor aquí: cualquier `setFieldValue`/setContent en el mismo tick
  // en que se desmonta el Dialog se pierde, y cerrar después del volcado volvía
  // a montar el modal (re-render de <Formik> con enableReinitialize).
  const applyHtmlDraft = () => {
    setHtmlPendiente(htmlDraft && htmlDraft.trim() !== "" ? htmlDraft : "<p><br></p>");
    setShowHtmlModal(false);
  };

  // Vuelca el HTML pendiente al editor UNA VEZ que el modal ya está cerrado.
  useEffect(() => {
    if (showHtmlModal || htmlPendiente === null) return;
    // OJO: `editorRef.current` puede apuntar a una instancia ya desmontada por el
    // re-render de <Formik>. Comprobamos que la instancia siga viva antes de
    // usarla; si no, el valor va directo a Formik y el editor lo repinta desde
    // `values.DESC_LARGA` al montarse de nuevo.
    const editor = editorRef.current;
    if (editor && typeof editor.setContent === "function") {
      editor.setContent(htmlPendiente);
      formikSetFieldValueRef.current?.("DESC_LARGA", editor.getContent());
    } else {
      formikSetFieldValueRef.current?.("DESC_LARGA", htmlPendiente);
    }
    setHtmlPendiente(null);
  }, [showHtmlModal, htmlPendiente]);

  const FormikAutocomplete = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();

    return (
      <Autocomplete
        disableClearable
        options={idiomas}
        value={idiomaSeleccionado}
        getOptionLabel={(option) => option.NOMBRE} // Asumiendo que cada idioma tiene una propiedad 'nombre'
        renderInput={(params) => <TextField {...params} label="Idioma" variant="standard" />}
        onChange={handleIdiomaChange} // Maneja el cambio de selección
      />
    );
  };

  const FormikAutocompleteTags = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const handleTagChange = (event, newValue) => {
      // Rastrear cada ID y cuántas veces aparece
      const idCounts = new Map();
      newValue.forEach((tag) => {
        idCounts.set(tag.ID, (idCounts.get(tag.ID) || 0) + 1);
      });

      // Filtrar para eliminar todos los tags cuyos IDs aparecen más de una vez
      const filteredNewValue = newValue.filter((tag) => idCounts.get(tag.ID) === 1);

      setTagSelected(filteredNewValue); // Actualiza el estado con los valores filtrados
      setFieldValue("TAGS", filteredNewValue); // Actualiza Formik
    };

    return (
      <Autocomplete
        disableClearable
        multiple
        options={tags}
        value={tagSelected}
        onChange={handleTagChange}
        getOptionLabel={(option) => option.NOMBRE}
        getOptionSelected={(option, value) => option.ID === value.ID}
        renderInput={(params) => <TextField {...params} label="Tags" variant="standard" />}
        // Asegurándonos de que cada opción tiene una clave única
        key={(option) => option.ID}
      />
    );
  };

  const titleNav = id == 0 ? "registro" : "registro " + data.TITULO;

  // Esquema de validación
  const validationSchema = Yup.object().shape({
    TITULO: Yup.string().max(500).required("Campo obligatorio"),
    FECHA_PUBLICACION: Yup.string().required("Campo obligatorio"),
    LANGUAGE_ID: Yup.number().required("Campo obligatorio"),
    SEO_TITLE: Yup.string().required("Campo obligatorio"),
    SEO_URL_FRIENDLY: Yup.string().required("Campo obligatorio"),
    // Incluye otras validaciones según corresponda
  });
  const handleSubmit = async (values, actions) => {
    try {
      var imgOK = await saveImgOnSubmit(values);
      if (!imgOK) return;
      const response = await saveData(values);
      if (response.ok) {
        const msgResponse = await response.json();
        // Si la solicitud fue exitosa
        if (msgResponse.error != "") {
          msgError(msgResponse.error);
        } else {
          msgOk();
          var id = msgResponse.response[0][""];
          navigate("/admin/noticias/" + id);
        }
      } else {
        // Si hubo un problema con la solicitud
        const errorData = await response.json(); // Suponiendo que el servidor responde con detalles del error en JSON
        msgError(`Error al guardar: ${errorData.message}`);
        // Aquí podrías establecer algún estado para mostrar el error en la UI en lugar de un alert
      }
    } catch (error) {
      msgError("Ocurrió un error al guardar los datos");
      console.error(error);
    } finally {
      actions.setSubmitting(false);
    }
  };
  /*CROPPPER*/
  const folderSave = "noticias";
  const [imageHasBeenCropped, setImageHasBeenCropped] = useState(false);
  const [showImageError, setShowImageError] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const [file, setFile] = useState(null);
  const [rootFile, setRootFile] = useState(null);
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    multiple: false,
    accept: {
      "image/*": [],
    },
    onDrop: (acceptedFiles) => {
      setRootFile(acceptedFiles[0]);
      setFile({
        ...acceptedFiles[0],
        preview: URL.createObjectURL(acceptedFiles[0]),
      });
    },
  });

  useEffect(() => {
    if (croppedImage) {
      setImageHasBeenCropped(true);
    } else {
      setImageHasBeenCropped(false);
    }
  }, [croppedImage]);

  async function saveImgOnSubmit(values) {
    var res = true;
    if (imageHasBeenCropped) {
      let image = values.IMAGEN;
      if (!image) {
        let fileToUpload = rootFile;
        if (croppedImage) {
          const res = await fetch(croppedImage);
          const blob = await res.blob();
          fileToUpload = new File([blob], rootFile.name, {
            type: rootFile.type,
          });
        }
        const data = new FormData();
        data.append("file", fileToUpload);
        const imageReq = await saveImgFolder(data, folderSave);
        const imageResult = imageReq.filename;
        // image = `${
        //   process.env.REACT_APP_API_BASE_URL
        // }/files/${folderSave}/${imageResult.path.split("\\").pop()}`.replaceAll("api/", "");
        var image_path =
          `${process.env.REACT_APP_API_BASE_URL}/files/${folderSave}/${imageResult}`.replaceAll(
            "api/",
            ""
          );
        image = imageResult;
      }
      setData({
        ...data,
        IMAGEN: image,
      });
      values.IMAGEN = image;
      setFile(null);
      setCroppedImage(null);
      // setSubmitForm(true);
    }
    if (!imageHasBeenCropped && !values.IMAGEN) {
      setShowImageError(true);
      res = false;
    }
    return res;
  }
  function getFullPathImg(img) {
    var image_path = `${process.env.REACT_APP_API_BASE_URL}/files/${folderSave}/${img}`.replaceAll(
      "api/",
      ""
    );
    return image_path;
  }
  // Manejar los cambios en handleQuillChange

  /*//CROPPER*/
  return (
    <DashboardLayout>
      <ToastContainer />
      <DashboardNavbar title={`Edición de ${titleNav}`} />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Edición del registro
                </MDTypography>
              </MDBox>
              <MDBox py={3} px={3}>
                <Formik
                  initialValues={data} // Usas directamente el estado data como initialValues
                  enableReinitialize // Esto asegura que los valores del formulario se actualicen cuando cambie data
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    errors,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    submitForm,
                    isSubmitting,
                    touched,
                    values,
                    setFieldValue,
                  }) => {
                    // Expone el setFieldValue de Formik a los handlers externos
                    // (botones del editor y selector de fecha).
                    formikSetFieldValueRef.current = setFieldValue;
                    return (
                      <Form>
                        <MDBox pt={0} pb={3}>
                          <Grid container spacing={6}>
                            <Grid item xs={12}>
                              <Grid container spacing={6}>
                                <Grid item xs={6}>
                                  <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                      <MDInput
                                        variant="standard"
                                        fullWidth
                                        name="TITULO"
                                        label="Título"
                                        error={touched.TITULO && Boolean(errors.TITULO)}
                                        value={values.TITULO}
                                        onChange={handleChange}
                                      />
                                      {touched.TITULO && errors.TITULO && (
                                        <FormHelperText error>{errors.TITULO}</FormHelperText>
                                      )}
                                    </Grid>

                                    <Grid item xs={12}>
                                      <FormikAutocompleteTags
                                        name="TAGS"
                                        fullWidth
                                        options={tags}
                                        getOptionLabel={(option) => option.label}
                                        onChange={handleChange}
                                        value={values.TAGS}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={6}>
                                  <Grid container spacing={4}>
                                    <Grid item xs={3} textAlign={"start"}>
                                      <FormControlLabel
                                        control={
                                          <Switch
                                            checked={values.ACTIVO}
                                            onChange={handleChange}
                                            name="ACTIVO"
                                          />
                                        }
                                        label="Activo"
                                      />
                                    </Grid>
                                    <Grid item xs={4}>
                                      {/* {selectedDate.format("DD/MM/YYYY")} */}
                                      <LocalizationProvider
                                        dateAdapter={AdapterDayjs}
                                        adapterLocale="es"
                                      >
                                        <DatePicker
                                          label="Fecha de publicación"
                                          value={selectedDate}
                                          onChange={handleDateChange}
                                          textField={{
                                            component: (params) => (
                                              <TextField
                                                {...params}
                                                InputProps={{
                                                  ...params.InputProps,
                                                  disabled: true,
                                                }}
                                              />
                                            ),
                                          }}
                                          error={
                                            touched.FECHA_PUBLICACION &&
                                            Boolean(errors.FECHA_PUBLICACION)
                                          }
                                        />
                                        {touched.FECHA_PUBLICACION && errors.FECHA_PUBLICACION && (
                                          <FormHelperText error>
                                            {errors.FECHA_PUBLICACION}
                                          </FormHelperText>
                                        )}
                                      </LocalizationProvider>
                                      {/* 
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker
                                        variant="standard"
                                        fullWidth
                                        name="FECHA_PUBLICACION"
                                        label="Fecha publicación"
                                        error={touched.FECHA_PUBLICACION && Boolean(errors.FECHA_PUBLICACION)}
                                        value={values.FECHA_PUBLICACION}
                                        onChange={handleChange}
                                        renderInput={(params) => <TextField {...params} />}
                                      />
                                      {touched.FECHA_PUBLICACION && errors.FECHA_PUBLICACION && (
                                        <FormHelperText error>{errors.FECHA_PUBLICACION}</FormHelperText>
                                      )}
                                    </LocalizationProvider> */}
                                    </Grid>
                                    <Grid item xs={5}>
                                      <FormikAutocomplete
                                        name="LANGUAGE_ID"
                                        fullWidth
                                        options={idiomas}
                                        getOptionLabel={(option) => option.label}
                                        label="Idioma"
                                        onChange={handleChange}
                                        value={values.LANGUAGE_ID}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12} pb={3}>
                                  <Box
                                    sx={{
                                      borderBottom: 2,
                                      borderColor: "black",
                                      width: "100%",
                                    }}
                                  ></Box>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sx={{
                                    paddingTop: "20px!important",
                                    borderRight: "1px solid #ccc",
                                    paddingRight: "30px",
                                  }}
                                >
                                  <Grid item xs={12} pb={3}>
                                    <MDTypography variant="h7">Panel SEO</MDTypography>
                                  </Grid>
                                  <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                      <MDInput
                                        variant="standard"
                                        fullWidth
                                        name="SEO_TITLE"
                                        label="Título"
                                        error={touched.SEO_TITLE && Boolean(errors.SEO_TITLE)}
                                        value={values.SEO_TITLE}
                                        onChange={handleChange}
                                      />
                                      {touched.SEO_TITLE && errors.SEO_TITLE && (
                                        <FormHelperText error>{errors.SEO_TITLE}</FormHelperText>
                                      )}
                                    </Grid>
                                    <Grid item xs={6}>
                                      <MDInput
                                        variant="standard"
                                        fullWidth
                                        name="SEO_URL_FRIENDLY"
                                        label="Url amigable"
                                        error={
                                          touched.SEO_URL_FRIENDLY &&
                                          Boolean(errors.SEO_URL_FRIENDLY)
                                        }
                                        value={values.SEO_URL_FRIENDLY}
                                        onChange={handleChange}
                                      />
                                      {touched.SEO_URL_FRIENDLY && errors.SEO_URL_FRIENDLY && (
                                        <FormHelperText error>
                                          {errors.SEO_URL_FRIENDLY}
                                        </FormHelperText>
                                      )}
                                    </Grid>
                                    <Grid item xs={6}>
                                      <MDInput
                                        variant="standard"
                                        fullWidth
                                        name="SEO_METAKEYWORD"
                                        label="MetaKeywords"
                                        // error={
                                        //   touched.SEO_METAKEYWORD && Boolean(errors.SEO_METAKEYWORD)
                                        // }
                                        value={values.SEO_METAKEYWORD + ""}
                                        onChange={handleChange}
                                      />
                                      {/* {touched.SEO_METAKEYWORD && errors.SEO_METAKEYWORD && (
                                      <FormHelperText error>
                                        {errors.SEO_METAKEYWORD}
                                      </FormHelperText>
                                    )} */}
                                    </Grid>
                                    <Grid item xs={6}>
                                      <MDInput
                                        variant="standard"
                                        fullWidth
                                        name="SEO_METADESCRIPTION"
                                        label="Metadescripción"
                                        // error={
                                        //   touched.SEO_METADESCRIPTION &&
                                        //   Boolean(errors.SEO_METADESCRIPTION)
                                        // }
                                        value={values.SEO_METADESCRIPTION}
                                        onChange={handleChange}
                                      />
                                      {/* {touched.SEO_METADESCRIPTION && errors.SEO_METADESCRIPTION && (
                                      <FormHelperText error>
                                        {errors.SEO_METADESCRIPTION}
                                      </FormHelperText>
                                    )} */}
                                    </Grid>
                                  </Grid>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sx={{
                                    paddingTop: "20px!important",
                                    // paddingLeft: "30px!important",
                                  }}
                                >
                                  <Grid container>
                                    <Grid item xs={11} pb={3} mb={3}>
                                      <MDTypography variant="h7">Imagen</MDTypography>
                                    </Grid>

                                    {file || values.IMAGEN ? (
                                      <Grid item xs={1}>
                                        <IconButton
                                          onClick={() => {
                                            setData({
                                              ...values,
                                              IMAGEN: "",
                                            });
                                            setFile(null);
                                            setCroppedImage(null);
                                            setImageHasBeenCropped(false);
                                          }}
                                        >
                                          <Close />
                                        </IconButton>
                                      </Grid>
                                    ) : (
                                      <Grid item xs={1} />
                                    )}
                                  </Grid>
                                  <Grid container spacing={4}>
                                    {/* IMG */}
                                    <>
                                      {values.IMAGEN !== "" && (
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            backgroundColor: "#eee",
                                            padding: "2rem",
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "300px",
                                          }}
                                        >
                                          <img src={getFullPathImg(values.IMAGEN)} alt="service" />
                                        </Box>
                                      )}
                                      {values.IMAGEN === "" && (
                                        <Grid container>
                                          {file && rootFile ? (
                                            <Grid
                                              item
                                              xs={12}
                                              sx={{
                                                ml: 0,
                                                mr: 0,
                                                minHeight: "350px",
                                                width: "100%",
                                                border: `1px dashed black`,
                                                borderRadius: "0px",
                                                textAlign: "center",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <Grid container>
                                                <Grid item xs={12}>
                                                  <MDTypography
                                                    sx={{
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Imagen Original
                                                  </MDTypography>
                                                  <Box
                                                    style={{
                                                      maxWidth: "100%",
                                                      padding: "1rem",
                                                      margin: "auto",
                                                    }}
                                                  >
                                                    <Cropper
                                                      imageToCrop={URL.createObjectURL(rootFile)}
                                                      croppedImage={(value) =>
                                                        setCroppedImage(value)
                                                      }
                                                      ratio={690 / 376}
                                                    />
                                                  </Box>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <MDTypography
                                                    sx={{
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    Vista Previa
                                                  </MDTypography>
                                                  {croppedImage ? (
                                                    <img
                                                      src={croppedImage}
                                                      alt="preview"
                                                      style={{ maxWidth: "90%", padding: "1rem" }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={file.preview}
                                                      alt="preview"
                                                      style={{ maxWidth: "90%", padding: "1rem" }}
                                                    />
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          ) : (
                                            <Grid
                                              item
                                              id="imageBAnnercontainer"
                                              xs={12}
                                              sx={{
                                                ml: "30px",
                                                mr: 0,
                                                minHeight: "250px",
                                                width: "100%",
                                                border: `1px dashed black`,
                                                borderRadius: "0px",
                                                padding: "2rem",
                                              }}
                                            >
                                              <UploadImageBanner rootProps={getRootProps} />
                                              <input
                                                accept=".jpg, .jpeg, .png, .gif, .svg, .pdf"
                                                {...getInputProps()}
                                              />
                                            </Grid>
                                          )}
                                        </Grid>
                                      )}
                                      {showImageError && (
                                        <MDTypography fontSize={14} color="error" px={4} pt={1}>
                                          Debe subir y recortar una imagen
                                        </MDTypography>
                                      )}
                                    </>
                                    {/* //IMG */}
                                  </Grid>
                                </Grid>

                                <Grid item xs={12} pb={0}>
                                  <Box
                                    sx={{
                                      borderBottom: 2,
                                      borderColor: "black",
                                      width: "100%",
                                    }}
                                  ></Box>
                                </Grid>
                                <Grid item xs={12}>
                                  <MDInput
                                    type="text"
                                    variant="standard"
                                    fullWidth
                                    name="DESC_CORTA"
                                    label="Descripción corta"
                                    error={touched.DESC_CORTA && Boolean(errors.DESC_CORTA)}
                                    value={values.DESC_CORTA}
                                    onChange={handleChange}
                                    multiline
                                    rows={5}
                                  />
                                  {touched.DESC_CORTA && errors.DESC_CORTA && (
                                    <FormHelperText error>{errors.DESC_CORTA}</FormHelperText>
                                  )}
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="" fontSize={"12px"} color={"#7b809a"}>
                                    Descripción larga
                                  </Typography>
                                  {/* El botón externo "CÓDIGO HTML" se retiró:
                                      TinyMCE ya trae su propio botón `code`
                                      (Source code) en la toolbar, que edita el
                                      HTML sin salir del componente. Mantener los
                                      dos era redundante. */}
                                  <Editor
                                    // Los assets se sirven LOCALES (copiados a
                                    // `public/tinymce`). Sin `tinymceScriptSrc`
                                    // el wrapper @tinymce/tinymce-react cae al
                                    // CDN de TinyMCE Cloud (`cdn.tiny.cloud` con
                                    // "no-api-key"), que es el producto de pago
                                    // y está prohibido en este plan.
                                    tinymceScriptSrc="/tinymce/tinymce.min.js"
                                    onInit={handleEditorRef}
                                    init={tinyMceInit}
                                    value={values.DESC_LARGA}
                                    onEditorChange={(content) => {
                                      // TinyMCE entrega siempre el HTML como
                                      // string; no hay `.root` que pueda faltar
                                      // (que era lo que tumbaba la app con Quill).
                                      setFieldValue("DESC_LARGA", content);
                                    }}
                                  />

                                  {/* {values.DESC_LARGA && values.DESC_LARGA && (
                                  <FormHelperText error>{errors.DESC_LARGA}</FormHelperText>
                                )} */}
                                </Grid>

                                <Grid item xs={12}>
                                  <MDBox display="flex" justifyContent="flex-end">
                                    <MDButton
                                      type="submit"
                                      variant="gradient"
                                      color="primary"
                                      size="medium"
                                    >
                                      GUARDAR DATOS
                                    </MDButton>
                                  </MDBox>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </MDBox>
                      </Form>
                    );
                  }}
                </Formik>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Dialog
        open={showHtmlModal}
        onClose={(event, reason) => {
          // El modal vive DENTRO de <Formik>/<Form>: un clic fuera (backdrop)
          // puede propagarse al formulario. Cerramos sin tocar nada más y
          // paramos la propagación para que no dispare submit ni recarga.
          if (event && typeof event.stopPropagation === "function") event.stopPropagation();
          setShowHtmlModal(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Código HTML de la descripción larga</DialogTitle>
        <DialogContent dividers>
          <Typography variant="caption" color="textSecondary">
            Pega o edita el HTML del cuerpo. Se aplicará al editor al pulsar Aplicar.
          </Typography>
          <TextField
            multiline
            fullWidth
            minRows={14}
            maxRows={24}
            variant="outlined"
            value={htmlDraft}
            onChange={(e) => setHtmlDraft(e.target.value)}
            sx={{ mt: 1, fontFamily: "monospace" }}
            InputProps={{ sx: { fontFamily: "monospace", fontSize: "12px" } }}
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={() => setShowHtmlModal(false)} color="dark">
            CANCELAR
          </Button>
          <Button type="button" onClick={applyHtmlDraft} variant="gradient" color="primary">
            APLICAR
          </Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default Edit;
